import { userListsClient } from 'src/clients'
import { UpsertUserListRequest, UserList } from 'src/common-services'
import { useRecoilMutation, UseRecoilMutationOptions } from 'src/utils/recoil'
import * as atoms from 'src/atoms/user-lists'
import cloneDeep from 'lodash/cloneDeep'
import { logEvent } from 'src/components/analytics'

export const useSaveUserList = (options?: UseRecoilMutationOptions<UserList>) => {
  return useRecoilMutation(
    ({ set }) =>
      async (request: UpsertUserListRequest) => {
        const { id, ...data } = request
        if (id) {
          const list = await userListsClient.updateList(id, data)
          logEvent('user-list', { action: 'updated' })
          set(atoms.userLists, (userLists) => {
            const originalUserLists = cloneDeep(userLists) || []
            const userListIndex = originalUserLists.findIndex((li) => li.id === list.id)
            if (userListIndex === -1) {
              return originalUserLists
            }
            originalUserLists[userListIndex] = { ...list, items: originalUserLists[userListIndex].items }
            return originalUserLists
          })
          return list
        } else {
          const list = await userListsClient.createList(data)
          logEvent('user-list', { action: 'created' })
          set(atoms.userLists, (userLists) => {
            const originalUserLists = cloneDeep(userLists) || []
            originalUserLists.push({ ...list, items: [] })
            return originalUserLists
          })
          return list
        }
      },
    [],
    { ...options }
  )
}
